import React from 'react';
import '../../../pages/NotFound/NotFound.scss';
import {RefreshCw, Sparkles} from "lucide-react";
import Button from "../../ui/Button/Button";

// Shown when the app crashes while rendering. Uses the 404 page's layout; it sits outside the router,
// so it navigates with plain links.
const CrashScreen = () => (
    <div className="NotFound">
        <a href="/" className="NotFound__logo">
            <span className="icon-tile icon-tile--gradient"><Sparkles size={18}/></span>
            Soulify
        </a>

        <div className="card NotFound__card">
            <h1>Something went wrong</h1>
            <p>We've been notified and will look into it. Reloading the page usually helps.</p>

            <div className="NotFound__buttons">
                <Button type={'button'} variant={'secondary'} title={'Go to my chats'}
                        onClick={() => window.location.assign('/')}/>
                <Button type={'button'} variant={'primary'} title={'Reload'} icon={<RefreshCw size={16}/>}
                        onClick={() => window.location.reload()}/>
            </div>
        </div>
    </div>
);

export default CrashScreen;
